/** Pure per-node diff of a live fault study against a persisted snapshot, matched
 *  by node_name. Powers the latest-vs-live compare (no history table). */

export interface FaultNodeDiff {
  node_name: string
  status: 'unchanged' | 'changed' | 'added' | 'removed'
  live_3ph_ka: number | null
  latest_3ph_ka: number | null
  delta_3ph_ka: number | null
  live_slg_ka: number | null
  latest_slg_ka: number | null
}

interface NodeLike {
  node_name: string
  fault_current_3ph_ka: number
  fault_current_slg_ka: number | null
}

const EPS = 1e-3

export function diffFaultStudies(
  live: NodeLike[],
  latest: NodeLike[],
): FaultNodeDiff[] {
  const latestByName = new Map(latest.map(n => [n.node_name, n]))
  const liveByName = new Map(live.map(n => [n.node_name, n]))
  const out: FaultNodeDiff[] = []

  for (const l of live) {
    const prev = latestByName.get(l.node_name)
    if (!prev) {
      out.push({
        node_name: l.node_name, status: 'added',
        live_3ph_ka: l.fault_current_3ph_ka, latest_3ph_ka: null, delta_3ph_ka: null,
        live_slg_ka: l.fault_current_slg_ka, latest_slg_ka: null,
      })
      continue
    }
    const delta = l.fault_current_3ph_ka - prev.fault_current_3ph_ka
    out.push({
      node_name: l.node_name,
      status: Math.abs(delta) < EPS ? 'unchanged' : 'changed',
      live_3ph_ka: l.fault_current_3ph_ka, latest_3ph_ka: prev.fault_current_3ph_ka,
      delta_3ph_ka: delta,
      live_slg_ka: l.fault_current_slg_ka, latest_slg_ka: prev.fault_current_slg_ka,
    })
  }
  for (const p of latest) {
    if (!liveByName.has(p.node_name)) {
      out.push({
        node_name: p.node_name, status: 'removed',
        live_3ph_ka: null, latest_3ph_ka: p.fault_current_3ph_ka, delta_3ph_ka: null,
        live_slg_ka: null, latest_slg_ka: p.fault_current_slg_ka,
      })
    }
  }
  return out
}
